import { render, staticRenderFns } from "./PostInstructor.vue?vue&type=template&id=1ca26764&"
import script from "./PostInstructor.vue?vue&type=script&lang=js&"
export * from "./PostInstructor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports